import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'

import context from '../main.js'


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
 // baseURL:context.baseApiUrl,
  // 超时
  timeout: 10000
})

// request拦截器
// 添加请求拦截器
service.interceptors.request.use(function (config) {


    console.log("-----//",config);
   // config.url = context.baseApiUrl+ config.url;
    let user = JSON.parse(window.localStorage.getItem('user'));
    if (user) {
        config.headers.Authorization = 'Bearer ' + user.token;
    }
    console.log(config);
    return config;
}, function (error) {
    // 对请求失败做处理
    return Promise.reject(error);
});
// 添加响应拦截器
service.interceptors.response.use(function (response) {
    // 对响应数据做处理
    console.log('返回');
    console.log(response);
    return response;
}, function (error) {
    // 对响应错误做处理
    //{"status": 401,"error": "Unauthorized","message": "未登录"}
    console.log('返回-错误');
    if (error.response) {

        switch (error.response.status) {
            case 400:
                //error.message = error.response.data[0].field + ":" + error.response.data[0].message;
                error.message = error.response.data[0].message;
                break;
            case 401:
                context.push({
                    path: '/login'
                })

                break;
            case 402:
                error.message = '用户名或者密码错误(402)';
                break;
            case 403:
                error.message = '拒绝访问(403)';
                break;
            case 404:
                error.message = '请求出错(404)';
                break;
            case 408:
                error.message = '请求超时(408)';
                break;
            default:

                if(error.response.data.message.indexOf("of underfind")<0){
                    error.message = error.response.data.message;
                }else{
                    error.message='网络异常';
                }
                break;
        }
        var _message = error.message;
        if (_message === undefined) {
            _message = `连接出错`;
        }
        Message({
            message: _message,
            type: 'error',
            duration: 5 * 1000
        })
    } else {
        var _message = error.response.data[0].message;
        if (_message === undefined) {
            _message = `连接出错`;
        }
        Message({
            message: _message,
            type: 'error',
            duration: 5 * 1000
        })
    }

    return Promise.reject(error);
});



export default service



// WEBPACK FOOTER //
// ./src/utils/request.js